import React, { useState } from "react";
import html2canvas from "html2canvas";
import { QRCodeCanvas } from "qrcode.react";
import { AiOutlineDownload, AiOutlinePrinter } from "react-icons/ai";
import { AiOutlineClose } from "react-icons/ai";

const QrCodeModal = ({ isOpen, onClose, row }) => {

    // Print function for the QR code and its labels
    const QrCodePrint = async () => {
        const qrContainer = document.getElementById("qrDownloadContainer");

        if (!qrContainer) {
            console.error("QR Container not found");
            return;
        }

        try {
            const canvas = await html2canvas(qrContainer, {
                scale: 3,
                width: 188,
                height: 114,
                useCORS: true,
                logging: true,
                allowTaint: true,
            });

            const dataUrl = canvas.toDataURL("image/png");

            if (dataUrl) {
                // Create a new window for printing
                const printWindow = window.open('', '_blank');
                printWindow.document.write(`
                    <html>
                        <head>
                            <title>Print Ticket</title>
                            <style>
                                @page { size: auto; margin: 0mm; }
                                body { margin: 0; padding: 0; }
                                img { width: 20%; height: auto; }
                            </style>
                        </head>
                        <body>
                            <img src="${dataUrl}" onload="window.print();window.close()" />
                        </body>
                    </html>
                `);
                printWindow.document.close();
            }
        } catch (error) {
            console.error("Error generating QR code image:", error);
        }
    };

    if (!isOpen) return null;

    return (
        <div className="modal show d-block" tabIndex="-1" role="dialog" style={{ backgroundColor: "rgba(0, 0, 0, 0.5)" }}>
            <div className="modal-dialog modal-dialog-centered" style={{ maxWidth: "240px" }} role="document">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">Ticket</h5>
                        <button className="btn btn-light rounded-circle border-0" onClick={onClose}>
                            <AiOutlineClose color="black" />
                        </button>
                    </div>
                    <div className="modal-body">
                        <div
                            id="qrDownloadContainer"
                            className="d-flex flex-row align-items-center justify-content-between my-3"
                            style={{
                                width: "188px",
                                height: "114px",
                                padding: "10px",
                                border: "1px solid #ddd",
                                borderRadius: "10px",
                                fontSize: "10px",
                                lineHeight: "1.2",
                            }}
                        >
                            {/* Left Section: Text Info */}
                            <div style={{ flex: "1", textAlign: "left", paddingRight: "5px" }}>
                                <div><strong>Libellé:</strong> {row?.product?.name}</div>
                                <div><strong>Code article:</strong> {row?.product?.productCode}</div>
                                <div><strong>Code à barres:</strong> {row?.product?.barcode}</div>
                                {row?.initial_selling_price && <div><strong>Prix:</strong> {row?.initial_selling_price}</div>}
                            </div>

                            {/* Right Section: QR Code */}
                            <div style={{ flex: "0 0 60px", textAlign: "center" }}>
                                <QRCodeCanvas
                                    value={row?.product?.barcode}
                                    size={60}
                                    bgColor={"#ffffff"}
                                    fgColor={"#0a75ad"}
                                    level={"H"}
                                    includeMargin={false}
                                    imageSettings={{
                                        src: "/thamer.jpg",
                                        height: 40,
                                        width: 40,
                                        excavate: true,
                                    }}
                                />
                            </div>
                        </div>
                    </div>

                    <div className="mb-3 d-flex gap-2 mx-3">
                        <button
                            onClick={QrCodePrint}
                            className="btn btn-success d-flex justify-content-center align-items-center gap-3 w-100 mt-4"
                        >
                            <AiOutlinePrinter /> Print Ticket
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default QrCodeModal;
